import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.css";
import search from "../../assets/logo (2).svg";
import "../../style/contactPage/contactpage.scss";
import { Link } from "react-router-dom";
import Offcanvas from "react-bootstrap/Offcanvas";
import { useLocation } from "react-router-dom";

import {
  Container,
  Row,
  Col,
  Spinner,
  Image,
  Nav,
  Navbar,
  NavDropdown,
} from "react-bootstrap";
import Header from "../work/header";
import Footer from "../work/footer";
import { useParams } from "react-router-dom";

const API_BASE_URL = "https://infoglans.com/search/wp-json/wp/v2";

function KapilBhalla() {
  const [acfData, setAcfData] = useState(null);
  const [imageUrl, setImageUrl] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [offcanvasOpen, setOffcanvasOpen] = useState(false);
  const [leadershipData, setLeadershipData] = useState(null);

  const handleOffcanvasToggle = () => {
    setOffcanvasOpen(!offcanvasOpen);
  };

  const handleOffcanvasClose = () => {
    setOffcanvasOpen(false);
  };

  const location = useLocation();
  const leader = location.state?.leader;
  // console.log("locationswdefr", location);

  useEffect(() => {
    const fetchImage = async () => {
      if (leader?.leadership_details) {
        setLeadershipData(leader.leadership_details);

        const mediaId = leader.leadership_details.portfolio_img;

        if (mediaId) {
          try {
            const res = await fetch(`${API_BASE_URL}/media/${mediaId}`);
            const data = await res.json();
            console.log("data", data);
            setImageUrl(data.source_url);
          } catch (err) {
            console.error("Error fetching image:", err);
          }
        }
      }
    };

    fetchImage();
  }, []);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    async function fetchData() {
      try {
        const res = await fetch(`${API_BASE_URL}/pages/202`);
        const json = await res.json();
        console.log("Fetched ACF data:", json);
        setAcfData(json.acf);
      } catch (err) {
        setError(true);
        console.error("Fetch error:", err);
      } finally {
        setIsLoading(false);
      }
    }

    fetchData();
  }, []);

  // ✅ Moved after hooks
  if (!leader) {
    return <p>Leader data not found. Please go back and try again.</p>;
  }

  // console.log("leadershipdata", leadershipData);

  return (
    <div>
      <header className="fixed header-transparent wide-container bg-white">
        <Container className="navigation-wrapper">
          <Navbar expand="lg" className="nav-row first-row">
            <Link to="/homepage" className="text-decoration-none">
              <Navbar.Brand className="brand-logo">
                <img
                  src={search}
                  width="178px"
                  height="33px"
                  alt="React Bootstrap logo"
                />
              </Navbar.Brand>
            </Link>
            <Navbar.Toggle
              aria-controls="basic-navbar-nav"
              onClick={handleOffcanvasToggle}
            />
            <Navbar.Offcanvas
              id="offcanvasNavbar"
              aria-labelledby="offcanvasNavbarLabel"
              placement="end"
              className="office-offcanvas-custom"
              show={offcanvasOpen}
              onHide={handleOffcanvasClose}
            >
              <Offcanvas.Header closeButton>
                <Offcanvas.Title id="offcanvasNavbarLabel"></Offcanvas.Title>
              </Offcanvas.Header>
              <Offcanvas.Body>
                <Navbar.Collapse id="basic-navbar-nav" className="ms-auto">
                  <Nav className="menu list-inline custom-ml" id="menu">
                    {/* <NavDropdown.Item href="#action3"> */}
                    <Nav.Link
                      as={Link}
                      to="/Office"
                      className={`${
                        offcanvasOpen ? "white-text" : "black-text"
                      } active`}
                    >
                      Office
                    </Nav.Link>
                    {/* </NavDropdown.Item> */}
                    {/* <NavDropdown.Item href="#action3"> */}
                    {/* <Link to="/works" className="text-decoration-none"> */}
                    <Nav.Link
                      as={Link}
                      to="/Works"
                      className={offcanvasOpen ? "white-text" : "black-text"}
                      href="/Works"
                    >
                      Works
                    </Nav.Link>
                    {/* </Link> */}
                    {/* </NavDropdown.Item> */}
                    {/* <NavDropdown.Item href="#action3"> */}
                    <Nav.Link
                      as={Link}
                      to="/News"
                      className={offcanvasOpen ? "white-text" : "black-text"}
                      // href="/News"
                    >
                      News
                    </Nav.Link>
                    {/* </NavDropdown.Item> */}
                    {/* <NavDropdown.Item href="#action3"> */}
                    <Nav.Link
                      as={Link}
                      to="/Contact"
                      className={offcanvasOpen ? "white-text" : "black-text"}
                      // href="/Contact"
                    >
                      Contact
                    </Nav.Link>
                    {/* </NavDropdown.Item> */}
                  </Nav>
                </Navbar.Collapse>
              </Offcanvas.Body>
            </Navbar.Offcanvas>
          </Navbar>
        </Container>
      </header>

      <div className="py-5 mt-5">
        {isLoading && <p className="text-center">Loading...</p>}
        {error && (
          <p className="text-danger text-center">
            Something went wrong. Please try again later.
          </p>
        )}

        {leadershipData ? (
          <div className="mt-3">
            <div
              style={{
                background: "linear-gradient(to bottom, #DADEE3, #F8F8F9)",
                padding: "0px 70px",
                width: "100%",
              }}
            >
              <Container className="mt-5">
                <Row className="align-items-center mb-5 leadership-align">
                  <Col md={6}>
                    <h3 className="fw-bold mt-2">
                      {leadershipData.portfolio_title ?? ""}
                    </h3>
                    <h5 className="text-muted">
                      {leadershipData.portfolio_desc ?? ""}
                    </h5>
                    <p>{leadershipData.kapil_bhalla_desc ?? ""}</p>
                  </Col>
                  <Col md={6}>
                    <Image
                      src={imageUrl}
                      alt="Portfolio"
                      className="img-fluid custom-img"
                    />
                  </Col>
                </Row>
              </Container>
            </div>

            <Container>
              <Row className="mb-4 leadership-align">
                <Col md={6}>
                  <h5 className="fw-semibold office-font-1">
                    {leadershipData.executive_education_title ?? ""}
                  </h5>
                  <p className="mb-2 office-font-3">
                    {leadershipData.executive_education_sub_title ?? ""}
                  </p>
                  <p className="office-font-2">
                    {leadershipData.executive_education_desc ?? ""}
                  </p>

                  <h5 className="fw-semibold mt-4 office-font-1">
                    {leadershipData.bachelor_education_title ?? ""}
                  </h5>
                  <p className="mb-2 office-font-3">
                    {leadershipData.bachelor_education_sub_title ?? ""}
                  </p>
                  <p className="office-font-2">
                    {leadershipData.bachelor_education_desc ?? ""}
                  </p>
                </Col>

                <Col md={6}>
                  <h5 className="fw-semibold office-font-1">
                    {leadershipData.master_education_title ?? ""}
                  </h5>
                  <p className="mb-2 office-font-3">
                    {leadershipData.master_education_sub_title ?? ""}
                  </p>
                  <p className="office-font-2">
                    {leadershipData.master_education_desc ?? ""}
                  </p>
                </Col>
              </Row>
            </Container>

            <Container>
              <Row className="leadership-align">
                <Col md={12} className="office-font-2">
                  <div
                    dangerouslySetInnerHTML={{
                      __html: leadershipData.desc_leadership ?? "",
                    }}
                  />
                </Col>
                {/* <Col md={6} className="office-font-2">
                  <div
                    dangerouslySetInnerHTML={{
                      __html: leadershipData.right_text ?? "",
                    }}
                  />
                </Col> */}
              </Row>
            </Container>
          </div>
        ) : (
          <p className="text-center text-muted">
            No leadership data available.
          </p>
        )}
      </div>
      <Footer />
    </div>
  );
}

export default KapilBhalla;
